/**
 * @generated SignedSource<<dc7f81879ec751167f0c081d04a76bec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PLUCategoryCreateQuery$variables = Record<PropertyKey, never>;
export type PLUCategoryCreateQuery$data = {
  readonly pluCategories: ReadonlyArray<{
    readonly color: string;
    readonly id: string;
  }>;
};
export type PLUCategoryCreateQuery = {
  response: PLUCategoryCreateQuery$data;
  variables: PLUCategoryCreateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PLUCategory",
    "kind": "LinkedField",
    "name": "pluCategories",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PLUCategoryCreateQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PLUCategoryCreateQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "be1f57a1cf457dfa7df342d5d67ac2fe",
    "id": null,
    "metadata": {},
    "name": "PLUCategoryCreateQuery",
    "operationKind": "query",
    "text": "query PLUCategoryCreateQuery {\n  pluCategories {\n    id\n    color\n  }\n}\n"
  }
};
})();

(node as any).hash = "32019863c3320d13bc8e51b8316b6702";

export default node;
